import { useMemo } from 'react';
import { useCustomRouteMatch } from '../../../hooks/useCustomRouteMatch';
import { getMetaPageLink } from '../utils';
import {
  GAME,
  CATEGORY_DETAIL,
  COMMON_ERROR,
} from '../../../constants/routeTemplates';

export const DYNAMIC_ROUTES = [GAME, CATEGORY_DETAIL, COMMON_ERROR];

export const useSpecificPageLink = () => {
  const { path, url } = useCustomRouteMatch();

  return useMemo(() => {
    return DYNAMIC_ROUTES.includes(path) ? getMetaPageLink(url) : null;
  }, [path, url]);
};
